import React, { useEffect } from 'react';

const ParasutAuthorize = () => {
  useEffect(() => {
    // Environment'a göre doğru URL'yi belirle
    const isDevelopment = process.env.NODE_ENV === 'development';
    const apiUrl = process.env.REACT_APP_API_URL || '';
    
    let fullUrl;
    if (isDevelopment) {
      // Development'da localhost:5000 kullan
      fullUrl = 'http://localhost:5000/parasut/authorize';
    } else {
      // Production'da /api/parasut/authorize kullan (backend'de her iki route da var)
      fullUrl = `${apiUrl}/parasut/authorize`;
    }
    
    console.log('Environment:', process.env.NODE_ENV);
    console.log('API URL:', apiUrl);
    console.log('Full URL:', fullUrl);
    console.log('Token:', localStorage.getItem('token'));
    
    fetch(fullUrl, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(res => {
        console.log('Response status:', res.status);
        console.log('Response headers:', res.headers);
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(data => {
        console.log('Response data:', data);
        if (data.success) {
          console.log('Paraşüt URL\'sine yönlendiriliyor:', data.authorization_url);
          window.location.href = data.authorization_url;
        } else {
          console.error("Paraşüt bağlantı hatası:", data.error);
          alert(`Paraşüt bağlantı hatası: ${data.error}`);
        }
      })
      .catch(err => {
        console.error("Bağlantı hatası:", err);
        alert(`Bağlantı hatası: ${err.message}`);
      });
  }, []);

  return (
    <div style={{ textAlign: "center", paddingTop: "50px" }}>
      <h2>Paraşüt'e yönlendiriliyorsunuz...</h2>
      <p>Lütfen bekleyin.</p>
      <p>Konsolu kontrol edin (F12).</p>
    </div>
  );
};

export default ParasutAuthorize;